import { render, staticRenderFns } from "./ParallaxHeader.vue?vue&type=template&id=2fc44196&lang=pug&"
import script from "./ParallaxHeader.vue?vue&type=script&lang=ts&"
export * from "./ParallaxHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports